import type { TimelineEvent } from '@claims/core';
import type { InOutKind } from './list/InOutBadge.js';

/** WHICH WAY A CASE TIMELINE EVENT WENT (ported 2026-10-18 with the medrec console's in and out marks, Rod's 10-17 pick 2a there): an AI
 *  call that dialed, a person's call log and a letter of representation went OUT from us; a claim number came IN; the case, a record added,
 *  the system's own step and a hold for a person are events. A request the system never dialed ("Request to X not called: ...", core
 *  timeline.ts) did not go out, so it is an event too (test/timeline-io.test.ts reads core's own words, so a change there shows). */
export function ioOf(e: TimelineEvent): InOutKind {
  switch (e.kind) {
    case 'call': return /^Request to .* not called/.test(e.text) ? 'event' : 'out';
    case 'callLog': case 'lor': return 'out';
    case 'claim': return 'in';
    default: return 'event';
  }
}
